<h1 matDialogTitle>Scan Stock Code</h1>

<mat-dialog-content>
  <form [formGroup]="form">
    <div style="display: flex; gap: 16px;">
      <div fxFlex="60">
        <mat-form-field style="width: 100%;">
          <mat-label>Stock Code</mat-label>
          <input matInput type="text" [formControlName]="'stockCode'" #scanInput
            (keydown.enter)="$event.preventDefault()" (keydown.tab)="$event.preventDefault()" (keyup.enter)="search()"
            (keydown.tab)="search()">
          <button *ngIf="form.value.stockCode && form.value.stockCode.length > 0" matSuffix mat-icon-button
            aria-label="Clear" (click)="form.controls['stockCode'].setValue(null)">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>
      <div fxFlex="20">
        <mat-form-field style="width: 100%;">
          <mat-label>Quantity</mat-label>
          <input matInput type="number" formControlName="qty" style="text-align: right;"
            (keydown.enter)="$event.preventDefault()" (keydown.tab)="$event.preventDefault()" (keyup.enter)="search()"
            (keydown.tab)="search()">
        </mat-form-field>
      </div>
      <div fxFlex="20">
        <button mat-raised-button color="primary" (click)="search()" [disabled]="!form.valid">Add</button>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button matDialogClose>Close</button>
</mat-dialog-actions>